import React from "react";
import { ChevronDown } from "lucide-react";
import UseContext from "hooks/useContext";
import TemplateRow, { ListTag } from "pages/missionTemplates/components/TemplateRow";

/**
 * Templates of one qualification: a header that folds the group (name and count),
 * then its rows.
 */
const TemplateGroup = ({ group, isCollapsed, onToggle, onPreview }) => {
    const { language } = UseContext();
    const label = (key, fallback) => language.getValue(`missionTemplate.list.${key}`, fallback);
    const title = group.qualification || label("noQualification", "Sans qualification");
    const contentId = `template-group-${group.key || "none"}`;

    return (
        <div className="border-b border-gray-100 last:border-b-0">
            <button
                type="button"
                onClick={() => onToggle(group.key)}
                aria-expanded={!isCollapsed}
                aria-controls={contentId}
                title={isCollapsed ? label("expandGroup", "Déplier le groupe") : label("collapseGroup", "Replier le groupe")}
                className="flex w-full items-center gap-2 bg-gray-50 px-5 py-2.5 text-left hover:bg-gray-100 focus:outline-none focus-visible:bg-gray-100"
            >
                <ChevronDown
                    size={16}
                    color="#6B7280"
                    aria-hidden="true"
                    className={`shrink-0 transition-transform ${isCollapsed ? "-rotate-90" : ""}`}
                />
                <span className="truncate text-xs font-medium leading-4 text-gray-700">{title}</span>
                <ListTag>{group.templates.length}</ListTag>
            </button>
            {!isCollapsed ? (
                <div id={contentId} className="border-t border-gray-100">
                    {group.templates.map((template) => (
                        <TemplateRow key={template._id} template={template} onPreview={onPreview} />
                    ))}
                </div>
            ) : null}
        </div>
    );
};

export default TemplateGroup;
